export default __webpack_public_path__ + "static/media/STECRV-1.6d3f20e5.png";